const CreditCardUsageType = {
  ServiceFees: 90,
  FlightSeats: 91,
};

export default CreditCardUsageType;
